import * as React from "react";
import styled from "../../styled-components";
import { Container } from "../../components/Container/Container";
import { SmallDivider } from "../../components/SmallDivider/SmallDivider";
import {
  EquityIcon,
  HealthcareIcon,
  PTOIcon,
  MealIcon,
  TeamEventsIcon,
  OpenOfficeIcon
} from "./PerksIcons";

const Section = styled.section`
  padding: 100px 20px;
`;

const Title = styled.h2`
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
`;

const CardContainer = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -15px;
`;

const Card = styled.div`
  align-items: center;
  border: 1px solid #f2f2f2;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  border-radius: 3px;
  display: flex;
  min-height: 120px;
  margin: 15px;
  padding: 28px;
  width: 292px;
`;

const CardTitle = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-size: 20px;
  line-height: 30px;
  margin-left: 20px;
  white-space: pre-line;
`;

const data = [
  {
    title: "Equity in \n Say",
    icon: EquityIcon
  },
  {
    title: "Healthcare Coverage",
    icon: HealthcareIcon
  },
  {
    title: "Flexible \n PTO",
    icon: PTOIcon
  },
  {
    title: "Catered \n Meals",
    icon: MealIcon
  },
  {
    title: "Monthly Team Events",
    icon: TeamEventsIcon
  },
  {
    title: "Open Work Environment",
    icon: OpenOfficeIcon
  }
];

const perkCards = () =>
  data.map((perk, index) => (
    <Card key={index}>
      {perk.icon()}
      <CardTitle>{perk.title}</CardTitle>
    </Card>
  ));

export const PerksSection = () => (
  <Section>
    <Container alignItems="center" flexDirection="column">
      <Title>Perks and Benefits</Title>
      <SmallDivider />
      <CardContainer>{perkCards()}</CardContainer>
    </Container>
  </Section>
);



// WEBPACK FOOTER //
// ./src/pages/Careers/PerksSection.tsx